const Full = () => import( '@/container/Full.vue')

// dashboard components
const headerTasks = () => import(/* webpackPrefetch: false */ '@/views/tasks/HeaderTaskBar.vue')

export default {
   path: '/tasks',
   component: Full,
   redirect: '/tasks',
   beforeEnter(to, from, next) {
      if (localStorage.getItem('token')) {
         next()
      } else {
         next('/signin')
      }
   },
   children: [
      {
         path: '/tasks',
         component: headerTasks,
         meta: {
            title: "Tasks"
         }
      },
      {
         path: '/tasks/:task_id',
         component: headerTasks,
         meta: {
            title: "Tasks"
         }
      },
      {
         path: '/tasks/assigned_tasks',
         component: headerTasks,
         meta: {
            title: "Assigned Tasks"
         }
      },
      {
         path: '/tasks/assigned_tasks/:task_id',
         component: headerTasks,
         meta: {
            title: "Assigned Tasks"
         }
      },
      {
         path: '/tasks/completed_tasks',
         component: headerTasks,
         meta: {
            title: "Completed Tasks"
         }
      },
      {
         path: '/tasks/rejected_tasks',
         component: headerTasks,
         meta: {
            title: "Rejected Tasks"
         }
      },
      {
         path: '/tasks/approved_tasks',
         component: headerTasks,
         meta: {
            title: "Approved Tasks"
         }
      },
      {
         path: '/tasks/pending_tasks',
         component: headerTasks,
         meta: {
            title: "Pending Tasks"
         }
      }
   ]
}